import {Link} from "react-router-dom"

export default function Footer(){
 return(
  <footer className="footer">

   <div className="footer-container">

    {/* COMPANY INFO */}

    <div className="footer-section">
     <h3>KPL Infotech</h3>
     <p>
      We provide ERP solutions, web development services
      and industrial training programs to help businesses
      and students grow with modern technology.
     </p>
    </div>


    {/* QUICK LINKS */}

    <div className="footer-section">
     <h4>Quick Links</h4>

     <ul>
      <li><Link to="/">Home</Link></li>
      <li><Link to="/#services">Services</Link></li>
      <li><Link to="/career">Career</Link></li>
      <li><Link to="/contact">Contact</Link></li>
     </ul>
    </div>


    {/* SERVICES */}

    <div className="footer-section">
     <h4>Services</h4>

     <ul>
      <li><Link to="/erp">ERP Solutions</Link></li>
      <li><Link to="/webdev">Web Development</Link></li>
      <li><Link to="/training">Industrial Training</Link></li>
     </ul>
    </div>


    {/* CONTACT */}

    <div className="footer-section">
     <h4>Contact</h4>

     <p>Delhi, India</p>
     <p><a href="mailto:kpl@kplinfotech.com">kpl@kplinfotech.com</a></p>
     <p>+91 XXXXX XXXXX</p>
    </div>

   </div>

  </footer>
 )
}
